import "@/App.css";
import Presentation from "./components/Presentation";

function App() {
  return <Presentation />;
}

export default App;
